import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/tones';

const ToneService = {

  deleteTone( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  getTones( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getTone( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  saveTone( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateTone( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default ToneService;



// WEBPACK FOOTER //
// ./services/ToneService.js